import { SelectedMenuContent } from '../../@types';

const isWidget = (content: SelectedMenuContent): boolean => !!(content as any).component;

export default isWidget;
